import { useConfig } from '@/config/useConfig'
import type { AuthenticationResult } from '@/types/authenticationResult'

export enum MFAMethod {
    Authenticator = 'SOFTWARE_TOKEN_MFA',
    SMS = 'SMS_MFA',
    Email = 'EMAIL_OTP'
}

export enum MFACountry {
    US = 'US',
    CA = 'CA'
}

export type EnrollmentInput = {
    username: string
    phone_number: string
    access_token: string
}

export type MFAChallengeInput = {
    access_token: string
    username: string
    session: string
    code: string
}

export type EnrollmentResponse = {
    success: boolean
    message: string
}

const state: { username?: string, authenticationResult?: AuthenticationResult, redirectUrlAfterLogin?: string, session?: string, sentTo?: string } = {
    username: undefined,
    authenticationResult: undefined,
    redirectUrlAfterLogin: undefined,
    session: undefined,
    sentTo: undefined
}

export const initRedirectAfterMFA = (username: string, authenticationResult: AuthenticationResult, redirectUrlAfterLogin: string) => {
    state.username = username
    state.authenticationResult = authenticationResult
    state.redirectUrlAfterLogin = redirectUrlAfterLogin
}

export const initSmsMfa = (session: string, sentTo: string) => {
    state.session = session
    state.sentTo = sentTo
}

export const getState = () => {
    return JSON.parse(JSON.stringify(state))
}

export const resetRedirectAfterMFA = () => {
    state.username = undefined
    state.authenticationResult = undefined
    state.redirectUrlAfterLogin = undefined
    state.session = undefined
    state.sentTo = undefined
}
